//#region imports

// react
import React, { useState } from 'react';

// custom components
import { Modal } from '_atoms';
import ChangeTableModal from './change-table-modal';

// styling
import { Colors, Spacing } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectTableNumber } from '_redux/slices/marketplace/user-marketplace';
import { selectOneRetailer } from '_redux/slices/marketplace/retailer';

// nav
import { useHistory } from 'react-router-dom';

//#endregion imports

const RetailerOfflineModal = (props) => {

    //#region local states
    //#endregion local states

    //#region handlers
    const handleDone = () => props.done();
    //#endregion handlers

    //#region redux
    const history = useHistory();
    const retailerInfo = useSelector(selectOneRetailer);
    //#endregion redux

    return (
        <div style={{
            padding: Spacing.SCALE_12,
            width: '100%',
            maxWidth: '700px',
            borderRadius: Spacing.SCALE_12,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            backgroundColor: '#fff',
        }}>

            {/* Header and Close Button */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: Spacing.SCALE_16,
            }}>
                <h5 style={{ margin: 0, fontWeight: 'bold', fontSize: 18 }}>{retailerInfo?.retailerName} is offline</h5>
                {/*<button
                    onClick={handleDone}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 24,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: '#888',
                        lineHeight: 1,
                    }}
                    aria-label="Close modal"
                >
                    &times;
                </button>*/}
            </div>

            {/* Body */}
            <div style={{ marginBottom: Spacing.SCALE_16 }}>
                <p style={{ marginBottom: 8 }}>Sorry for the inconvenience.</p>
                <p style={{ marginBottom: 8 }}>This retailer is currently offline and not accepting orders.</p>
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: Spacing.SCALE_12 }}>
                <button
                    //onClick={() => history.push('/qr-code-generator')}
                    onClick={() => window.location.reload()}
                    style={{
                        padding: `${Spacing.SCALE_10}px ${Spacing.SCALE_16}px`,
                        backgroundColor: Colors.PRM_LIGHT_BLUE,
                        color: 'white',
                        border: 'none',
                        borderRadius: Spacing.SCALE_6,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                >
                    Refresh Page
                </button>
            </div>
        </div>
    );
};

export default RetailerOfflineModal;
